import * as React from "react";
import { Link } from "react-router";

import styles from "./Breadcrumb.module.css";

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

export interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
  grayAncestors?: boolean;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, className, grayAncestors }) => (
  <div className={`${styles.breadcrumb}${className ? ` ${className}` : ""}`}>
    {items.map((item, idx) => (
      <React.Fragment key={idx}>
        {idx > 0 && <i className={`fa-solid fa-chevron-right ${styles.breadcrumbSep}`} />}
        {item.to ? (
          <Link to={item.to} className={`${styles.breadcrumbLink}${grayAncestors && idx < items.length - 1 ? ` ${styles.grayAncestor}` : ""}`}>{item.label}</Link>
        ) : (
          <span className={`${styles.breadcrumbCurrent}${grayAncestors && idx < items.length - 1 ? ` ${styles.grayAncestor}` : ""}`}>{item.label}</span>
        )}
      </React.Fragment>
    ))}
  </div>
);
